import React from 'react';
import PageHeader from '../components/PageHeader';
import usePageMeta from '../utils/usePageMeta';
import { company } from '../data/site';

// TODO: have this policy reviewed by a legal advisor before launch.
const LAST_UPDATED = '23 October 2026';

const PrivacyPage = () => {
  usePageMeta('Privacy Policy', `How ${company.legalName} collects, uses and protects personal information shared through this website.`);

  return (
    <>
      <PageHeader
        eyebrow="Legal"
        title="Privacy Policy"
        subtitle={`Last updated: ${LAST_UPDATED}`}
      />
      <section className="section">
        <div className="container legal">
          <div className="blog-body">
            <p>
              This policy explains how {company.legalName} (&ldquo;we&rdquo;, &ldquo;us&rdquo;) collects, uses and
              protects personal information when you visit this website or contact us. We process personal
              data in line with India&rsquo;s Digital Personal Data Protection Act, 2023.
            </p>

            <h2>Information we collect</h2>
            <p>We only collect information you choose to share with us, such as when you:</p>
            <ul>
              <li>Fill in the contact or quote request form (name, email address and project details)</li>
              <li>Email, call or message us on WhatsApp</li>
            </ul>
            <p>
              Our hosting provider may also record standard technical information such as your IP address,
              browser type and pages visited, to keep the website secure and working properly.
            </p>

            <h2>How we use your information</h2>
            <ul>
              <li>To respond to your enquiry and prepare quotes</li>
              <li>To deliver and support projects you engage us for</li>
              <li>To improve our website and services</li>
            </ul>
            <p>We do not sell your personal information or use it for unrelated marketing.</p>

            <h2>Analytics</h2>
            <p>
              We use Google Analytics and Microsoft Clarity to understand how visitors use our website, such
              as which pages are visited, how people navigate and where they leave, so we can improve it.
              These tools use cookies and may record anonymised interactions such as clicks and scrolling.
              Form fields are masked and we do not use these tools to identify you personally. You can opt out
              of Google Analytics with the{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics opt-out add-on</a>.
            </p>

            <h2>Advertising and cookies</h2>
            <p>
              Our blog pages may display advertisements served by Google AdSense. Google and its partners
              use cookies to show ads based on your visits to this and other websites. You can learn how
              Google uses this information at{' '}
              <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">
                policies.google.com/technologies/partner-sites
              </a>{' '}
              and turn off personalised ads in{' '}
              <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">Google Ad Settings</a>.
              Ads are never shown on our service pages or forms, and we do not share your form details with advertisers.
            </p>

            <h2>Who we share it with</h2>
            <p>
              We use trusted service providers to operate this website and handle enquiries, such as our
              website hosting provider and our form and email services. They process data only on our behalf.
              We may also disclose information where required by law.
            </p>

            <h2>How long we keep it</h2>
            <p>
              We keep enquiry details only as long as needed to respond and, if you become a client, for the
              duration of our work together and any period required by law. You can ask us to delete your
              information at any time.
            </p>

            <h2>Your rights</h2>
            <p>You can ask us to:</p>
            <ul>
              <li>Tell you what personal data we hold about you</li>
              <li>Correct or update your information</li>
              <li>Delete your information</li>
              <li>Withdraw consent you have given us</li>
            </ul>

            <h2>Security</h2>
            <p>
              We use reasonable technical and organisational measures to protect your information, including
              encrypted connections (HTTPS) and access controls. No method of transmission over the internet
              is completely secure, but we work to protect your data.
            </p>

            <h2>Contact us</h2>
            <p>
              For any privacy question or request, email us at{' '}
              <a href={`mailto:${company.email}`}>{company.email}</a> or write to us at {company.address}.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPage;
